import { SET_NOTIFICATION, SET_LOADING } from "../mutations.type";

export const state = {
  notification: {
    showing: false,
    color: "success",
    message: "",
    timeout: 5000,
  },
  loading: {
    status: false,
    circular: true,
  },
};

const mutations = {
  [SET_NOTIFICATION](state, snackbar) {
    state.notification.showing = true;
    state.notification.color = snackbar.color;
    state.notification.message = snackbar.message;
    if (typeof snackbar.timeout == "undefined" || snackbar.timeout == null) {
      state.notification.timeout = 5000;
    } else {
      state.notification.timeout = snackbar.timeout;
    }
  },
  [SET_LOADING](state, [status, circular]) {
    state.loading.status = status;
    state.loading.circular = circular;
  },
};

const getters = {
  notification(state) {
    return state.notification;
  },
  loading(state) {
    return state.loading;
  },
};

export default {
  state,
  mutations,
  getters,
};
